<script lang="ts">
	const {
		title,
		message,
		buttonLink,
		buttonText
	}: { title: string; message: string; buttonLink?: string; buttonText?: string } = $props();
</script>

<div class="bg-base-100 container flex flex-col items-center gap-3 p-3">
	<div class="text-accent text-3xl font-bold">{title}</div>
	<div>{message}</div>
	{#if buttonLink}
		<a class="btn btn-outline btn-accent" href={buttonLink}>
			{buttonText}
		</a>
	{/if}
</div>
